import React, {useState,useEffect,useCallback} from 'react';
//import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import { useCookies } from 'react-cookie';
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
//import Table from '@mui/material/Table';
//import TableBody from '@mui/material/TableBody';
//import List from '@mui/material/List';
//import ListItem from '@mui/material/ListItem';
//import ListItemIcon from '@mui/material/ListItemIcon';
//import ListItemText from '@mui/material/ListItemText';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
//import VisibilityIcon from '@mui/icons-material/Visibility';
//import AccountBoxIcon from '@mui/icons-material/AccountBox';
//import BookIcon from '@mui/icons-material/Book';
//import CheckIcon from '@mui/icons-material/Check';
//import LaunchIcon from '@mui/icons-material/Launch';
//import MessageIcon from '@mui/icons-material/Assignment';
//import CopyToClipboard from 'react-copy-to-clipboard';
//import MultiLines from './MultiLines';
import RowData from './RowData';
import BottomButtons from './BottomButtons';
import {Inc,Owner,CookieHashName} from './Inc';
//import StoreImg from './StoreImg';
//import RowTable from './RowTable';
import Ajax from './Ajax';
import Loading from './Loading';
import Toast from './Toast';
//import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Title from './Title';


interface CustomerDetailProps {
	owner:Owner,
}

const CustomerDetail = (props:CustomerDetailProps)=> {
    Ajax.setEditorId( props.owner.owner_id );
	const [cookies, setCookie, removeCookie] = useCookies(['customer_id']);

    const classes = useStyles();
    const [states,setStates] = useState({
        customer: Inc.defaultCustomer(),
        isLoading:true,
    });
	const [toast,setToast] = useState('');
	//const copy = ()=>{
	//	setToast('クリップボードにURLをコピーしました');
	//}
	//const dummy = ()=>{
		
	//}
	const closeToast = ()=>{
		setToast('');
	}
	const readCookie = useCallback(()=>{
		//console.log("cookies",cookies);
		let cookieData:{[key:string]:string;} = {};
		if( cookies[CookieHashName] ){
			//console.log("readCookie",cookies[CookieHashName]);
			const lines = cookies[CookieHashName].split(/\n/);
			for( let i=0 ; i<lines.length ; i++ ){
				const sp = lines[i].split(/\t/);
				cookieData[ sp[0] ] = sp[1];
			}
		} else {
			//localStorage.removeItem('ownerId');
		}
		return cookieData;
	},[cookies]);

    useEffect( ()=>{
		window.scrollTo(0,0);
		const cookieData = readCookie();
        if( cookieData.customer_id ){
            Ajax.send("profile/customer",{customer_id:cookieData.customer_id},(res:any)=>{
                if( res.ok ){
                    setStates({...states,"isLoading":false,"customer":Inc.convCustomer(res.customer)})
                }
            });
        } else {
            setStates({...states,"isLoading":false});
        }
    } ,[]);

    if( states.isLoading ){
        return (
            <Loading isLoading={true}/>
        )
    }

	const toMypage = process.env.REACT_APP_DEPARTURL + "/account/customer";

	return (
		<div id="profile_detail" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={9}>
                    <Paper className={classes.paper}>
                        <Title text="連絡先" second="（会員登録）" icon="portrait"/>
						<div style={{marginBottom:"2em"}}>
						氏名や住所・電話番号など連絡先（会員登録）の修正はSideBではなく架空ストアのマイページで行います。<br/>
						委託終了時の商品の返送先や重要なお知らせなどで利用しますので、登録内容に間違いがないようご注意ください。<br/>
						</div>
						<FormControl style={{marginBottom:"1em"}}>
							<a href={toMypage}><Button variant="contained" color="primary" style={{width:"100%"}}><ArrowForwardIcon style={{marginRight:"0.5em"}}/>マイページへ行く</Button></a>
						</FormControl>

                    </Paper>
                </Grid>
            </Grid>
			<Toast mes={toast} close={closeToast}/>
		</div>
	);
}

export default CustomerDetail;
